import React from "react";
import { Skeleton } from "@picklebet/ui";
import { useSelectedCard } from "@/features/wallet/components/deposit/hooks/useSelectedCard";
import { CardIcon } from "./CardIcon";
import { MethodIcon } from "../method-row/MethodIcon";
import { ReactComponent as DebitCardIcon } from "@/features/wallet/assets/debit-card.svg";
import * as styles from "./CardMethodIcon.module.scss";

export const CardMethodIcon = () => {
  const { selectedCard, isLoading } = useSelectedCard();

  if (isLoading) {
    return <Skeleton className={styles.iconSkeleton} />;
  }

  return selectedCard ? (
    <CardIcon card={selectedCard} />
  ) : (
    <MethodIcon>
      <DebitCardIcon />
    </MethodIcon>
  );
};
